module.exports = __webpack_public_path__ + "static/media/vishing_bg.0db2020b.jpg";